import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';

interface HotelBenchmarkInsightChartsLegendItemsLegendInfoIconWithTooltipSignature {
  Args: {
    tooltipContent: unknown;
  };
}

const HotelBenchmarkInsightChartsLegendItemsLegendInfoIconWithTooltip =
  <template>
    {{! @glint-nocheck: not typesafe yet }}
    <div>
      <PrismIcon @name="circle-information-outline" @size="extra-small" />
      <EmberTooltip
        @arrowClass="prism-tooltip__arrow"
        @tooltipClass="prism-tooltip"
      >
        {{#if @tooltipContent.title}}
          <p class="paragraph-200--bold">{{@tooltipContent.title}}</p>
        {{/if}}
        <p class="paragraph-200--regular">
          {{@tooltipContent.prefix}}

          <span class="paragraph-200--bold">
            {{#if @tooltipContent.suffix}}
              {{@tooltipContent.suffix}}
            {{/if}}
          </span>
        </p>
      </EmberTooltip>
    </div>
  </template> satisfies TOC<HotelBenchmarkInsightChartsLegendItemsLegendInfoIconWithTooltipSignature>;

export default HotelBenchmarkInsightChartsLegendItemsLegendInfoIconWithTooltip;
